import { Question } from './types';

export const questions: Question[] = [
  {
    id: 'size',
    text: 'How many employees will be using the CRM?',
    options: [
      {
        text: 'Small (1-10 employees)',
        score: { pipedrive: 10, hubspot: 5 }
      },
      {
        text: 'Medium (11-50 employees)',
        score: { pipedrive: 8, hubspot: 8 }
      },
      {
        text: 'Large (50+ employees)',
        score: { pipedrive: 5, hubspot: 10 }
      }
    ]
  },
  {
    id: 'budget',
    text: 'What is your monthly budget for CRM software per user?',
    options: [
      {
        text: '$0-30',
        score: { pipedrive: 10, hubspot: 5 }
      },
      {
        text: '$31-70',
        score: { pipedrive: 8, hubspot: 8 }
      },
      {
        text: '$70+',
        score: { pipedrive: 5, hubspot: 10 }
      }
    ]
  },
  {
    id: 'industry',
    text: 'Which industry best describes your business?',
    options: [
      {
        text: 'B2B Sales / Professional Services',
        score: { pipedrive: 10, hubspot: 7 }
      },
      {
        text: 'E-commerce / Retail',
        score: { pipedrive: 6, hubspot: 9 }
      },
      {
        text: 'Technology / SaaS',
        score: { pipedrive: 7, hubspot: 10 }
      }
    ]
  },
  {
    id: 'salesCycle',
    text: 'What is your typical sales cycle length?',
    options: [
      {
        text: 'Short (Less than 2 weeks)',
        score: { pipedrive: 10, hubspot: 6 }
      },
      {
        text: 'Medium (2-8 weeks)',
        score: { pipedrive: 8, hubspot: 8 }
      },
      {
        text: 'Long (2+ months)',
        score: { pipedrive: 5, hubspot: 10 }
      }
    ]
  },
  {
    id: 'complexity',
    text: 'How complex are your sales processes?',
    options: [
      {
        text: 'Simple and straightforward',
        score: { pipedrive: 10, hubspot: 5 }
      },
      {
        text: 'Moderate complexity',
        score: { pipedrive: 7, hubspot: 8 }
      },
      {
        text: 'Complex with multiple stages',
        score: { pipedrive: 5, hubspot: 10 }
      }
    ]
  },
  {
    id: 'marketing',
    text: 'What level of marketing automation do you need?',
    options: [
      {
        text: 'Basic email campaigns only',
        score: { pipedrive: 10, hubspot: 5 }
      },
      {
        text: 'Multi-channel campaigns',
        score: { pipedrive: 6, hubspot: 8 }
      },
      {
        text: 'Full marketing suite with automation',
        score: { pipedrive: 4, hubspot: 10 }
      }
    ]
  },
  {
    id: 'integration',
    text: 'How many third-party tools do you need to integrate?',
    options: [
      {
        text: 'Just email and calendar',
        score: { pipedrive: 10, hubspot: 6 }
      },
      {
        text: '3-5 tools',
        score: { pipedrive: 7, hubspot: 8 }
      },
      {
        text: '5+ tools or complex integrations',
        score: { pipedrive: 4, hubspot: 10 }
      }
    ]
  },
  {
    id: 'reporting',
    text: 'What level of reporting and analytics do you need?',
    options: [
      {
        text: 'Basic sales reports',
        score: { pipedrive: 10, hubspot: 6 }
      },
      {
        text: 'Advanced sales analytics',
        score: { pipedrive: 7, hubspot: 8 }
      },
      {
        text: 'Full business intelligence suite',
        score: { pipedrive: 4, hubspot: 10 }
      }
    ]
  },
  {
    id: 'customization',
    text: 'How much customization do you need?',
    options: [
      {
        text: 'Minimal customization',
        score: { pipedrive: 10, hubspot: 6 }
      },
      {
        text: 'Moderate customization',
        score: { pipedrive: 7, hubspot: 8 }
      },
      {
        text: 'Extensive customization',
        score: { pipedrive: 5, hubspot: 10 }
      }
    ]
  }
];